<template>
    <!-- <v-container > -->
      <v-row>
        <v-col cols="12">
          <v-item-group class='hidden-md-and-up px-0 py-4'>
            <v-container>
              <v-row>
                <v-col
                  v-for="(item, i) in systemMenuList"
                  :key="i"
                  cols="12"
                  class="pa-2"
                >
                  <v-item v-slot="{ active }">
                    <v-card
                      :color="active ? '#F1FDF9' : 'white'"
                      :class="[active ? 'mobile-card-active' : 'mobile-card-normal']"
                      class="d-flex align-center rounded-xl py-3 px-3 elevation-2 mb-2"
                      v-ripple="{ class: 'green--text' }"
                      @click="goItem({code: item.pgmId, menu: item.ename})"
                    >
                      <div class="mobile-icon-container mr-4">
                        <v-img
                          :src="item.imgButton"
                          height="55"
                          width="55"
                          contain
                        ></v-img>
                      </div>

                      <v-list-item-content>
                        <v-list-item-title class="mobile-menu-title font-weight-bold">
                          {{ item.ename }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="grey--text text--darken-1 caption">
                          Nhấn để mở tính năng
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon :color="active ? '#49D9A0' : 'grey lighten-1'">
                          mdi-chevron-right-circle
                        </v-icon>
                      </v-list-item-action>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>        

          <v-item-group mandatory class='hidden-sm-and-down'>
            <v-container>
              <v-row class="fill-height">
                <v-col
                  cols="12"
                  md="3"
                  v-for="(item, i) in systemMenuList"
                  :key="i"
                  class="pa-4"
                >
                  <v-item v-slot="{ active }">
                    <v-hover v-slot="{ hover }">
                      <v-card
                        :elevation="hover ? 12 : 2"
                        :class="[
                          'menu-card-pc', 
                          active ? 'active-card' : '', 
                          hover ? 'hover-effect' : ''
                        ]"
                        class="d-flex align-center justify-center rounded-xl"
                        height="200"
                        @click="goItem({code: item.pgmId, menu: item.ename, link: item.linkAddr})"
                      >
                        <div class="text-center px-4 w-100">
                          <div class="icon-wrapper mb-4">
                            <v-img
                              :src="item.imgButton"
                              max-height="90"
                              max-width="90"
                              contain
                              class="mx-auto img-transition"
                            ></v-img>
                          </div>

                          <div class="menu-label">
                            {{ item.ename }}
                          </div>
                          
                          <div class="status-indicator" :class="{ 'is-active': active }"></div>
                        </div>
                      </v-card>
                    </v-hover>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-col>
      </v-row>
    <!-- </v-container> -->
</template>

<script>
import { getSystemMenu } from '@/api/system/menuManage'


export default {
  name: "v80Menu",
  data: () => ({
    selected: [0],
    toggle_exclusive: 1,
    systemMenuList:[],
    dataInfo: null
  }),
  components: {
   
  },
  created() {
    // this.$store.dispatch("IsMenuName", this.msg);
    this.$emit("MenuName", {code:'main', name: 'TQM'}); 
    // this.$emit("MenuName", obj.menu);
  },
  mounted() {    
    this.getSystemMenuList()
  },

  methods: {
    getSystemMenuList(){
      this.systemMenuList = []
      let param = {
        userId: this.$store.state.user.userId,
        sysCd: '80',//this.$store.state.system.sysCd,
      }
      getSystemMenu(param).then(res => {
        // console.log('########systemMenuList=====>', res)
        this.systemMenuList = res.list
      })
    },

    goItem(obj) {      
      if(!obj.code) {
        this.vToastify('Chức năng đang phát triển', 'info');
        return;
      }

      // Tạo hiệu ứng chờ nhẹ để người dùng thấy feedback click
      setTimeout(() => {
        if (obj.code === 'webpage'){
          window.open(obj.link)
        } else {
          this.$emit("MenuName", {code:'80', name: obj.menu});
          this.$router.push("/" + obj.code).catch(e => {
            console.error(e);
          });
        }
      }, 150); // 150ms là khoảng thời gian vàng cho cảm giác mượt mà
    },

  },

};
</script>
<style scoped>
  /* Cấu hình chung cho Card trên PC */
  .menu-card-pc {
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    border: 1px solid #eceff1 !important;
    background-color: #ffffff !important;
    overflow: hidden;
    position: relative;
  }

  /* Hiệu ứng khi rê chuột vào (Hover) */
  .hover-effect {
    transform: translateY(-10px);
    border-color: #49D9A0 !important;
  }

  /* Hiệu ứng phóng to nhẹ cho Icon */
  .hover-effect .img-transition {
    transform: scale(1.15);
  }

  /* Card khi đang được kích hoạt (Active) */
  .active-card {
    background: linear-gradient(145deg, #ffffff, #f1fdf9) !important;
    border-left: 5px solid #49D9A0 !important;
  }

  /* Định dạng nhãn chữ */
  .menu-label {
    color: #263238;
    font-size: 1.05rem;
    font-weight: 600;
    text-transform: capitalize;
    transition: color 0.3s;
  }

  .hover-effect .menu-label {
    color: #49D9A0;
  }

  /* Thanh trang trí phía dưới */
  .status-indicator {
    width: 0;
    height: 3px;
    background-color: #49D9A0;
    margin: 8px auto 0;
    border-radius: 10px;
    transition: width 0.3s ease;
  }

  .is-active.status-indicator, 
  .hover-effect .status-indicator {
    width: 50px;
  }

  /* Hiệu ứng chuyển động mượt cho hình ảnh */
  .img-transition {
    transition: transform 0.3s ease-in-out;
  }

  /* Đảm bảo nội dung căn giữa */
  .w-100 {
    width: 100%;
  }

  /* Tùy chỉnh riêng cho Mobile Card */
  .mobile-card-normal {
    transition: transform 0.2s ease, background-color 0.3s;
    border: 1px solid #f0f0f0 !important;
  }

  /* Hiệu ứng khi nhấn (Active/Touch) */
  .mobile-card-active {
    border: 1.5px solid #49D9A0 !important;
    transform: scale(0.98); /* Hiệu ứng nhấn lún xuống nhẹ */
  }

  /* Định dạng chữ trên mobile */
  .mobile-menu-title {
    font-size: 1.0rem !important;
    color: #2c3e50;
    letter-spacing: 0.3px;
  }

  .mobile-card-active .mobile-menu-title {
    color: #2e7d32;
  }

  /* Bo góc cho vùng chứa Icon */
  .mobile-icon-container {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-card-active .mobile-icon-container {
    background: #ffffff;
  }

  /* Hiệu ứng đổ bóng mượt hơn cho Vuetify */
  .elevation-2 {
    box-shadow: 0 3px 10px rgba(0,0,0,0.05) !important;
  }

  /* Hiệu ứng click phản hồi nhanh */
  .menu-card-pc:active, .mobile-card-normal:active {
    transform: scale(0.95);
    transition: transform 0.1s;
  }

  /* Thêm hiệu ứng trượt nhẹ cho toàn bộ container khi vừa vào menu */
  .v-item-group {
    animation: fadeInUp 0.6s ease-out;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>

